import { CodeCatalogHit } from "../../graphql";
import React from "react";
import CodeListItemRegular from "./CodeListItemRegular";

type Props = {
    item: CodeCatalogHit;
};

const CodeCatalogListViewItem: React.FC<Props> = ({ item }) => {
    return (
        <>
            <CodeListItemRegular
                key={item.id}
                title={item.title}
                no={item.no}
                description={item.description}
                series={item.series}
                image={item.imagePath?.replace("/image?path=", "")}
                to={`/codes/details/${item.id}`}
                bustTypes={item.busTypes}
                isPreview={item.isPreview}
            />
        </>
    );
};

export default CodeCatalogListViewItem;
